module.exports = __webpack_public_path__ + "static/img/1.500de6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/1.png
// module id = R9MB
// module chunks = 0